module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c0878b928f59a5f14d0436a4748a8731.png";